module.exports = __webpack_public_path__ + "media/anim1.4385dd61.webm";